<template>
  <!-- 审核信息展示区域 -->
  <a-modal
    :title="title"
    :visible="blackVisible"
    width="800px"
    @cancel="handleClose"
  >
    <div class="taskModal-top">
      <p>
        任务标题：<span>{{ auditList.title }}</span>
      </p>
      <p>发送时间：<span>立即发送</span></p>
      <p>
        短信通道：<span>{{ auditList.sendAisle_dictText }}</span>
      </p>
    </div>
    <p class="taskModal-table">消息：</p>
    <a-table
      ref="table"
      size="middle"
      bordered
      :scroll="{ x: 600 }"
      :rowKey="(record) => record.id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <span slot="paramFormats" slot-scope="text">
        {{ text ? text.userName : '--' }}
      </span>
    </a-table>
    <template slot="footer" v-if="title == '审核'">
      <a-button type="" @click="handleCancel"> 审核驳回 </a-button>
      <a-button type="primary" @click="handleOk"> 审核通过 </a-button>
    </template>
    <template slot="footer" v-if="title == '查看'">
      <a-button type="primary" @click="handleClose"> 确定 </a-button>
    </template>
    <!-- 审核驳回 -->
    <a-modal
      v-model="checkVisible"
      title="审核"
      width="800px"
      @cancel="checkVisible == false"
    >
      <template slot="footer">
        <a-button @click="handleReview()">取消</a-button>
        <a-button type="primary" @click="auditOk()">确定</a-button>
      </template>
      <a-form :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-form-item label="审核驳回理由">
          <a-input placeholder="请输入理由" v-model="auditReason"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-modal>
</template>
<script>
import { postTag } from '@/api/manage';
import customRender from '@/utils/customRender.js';
export default {
  name: 'MessageTaskModal',
  data() {
    return {
      title: '审核',
      loading: false,
      auditReason: '',
      auditList: {},
      selectedRowKeys: [],
      selectionRows: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },

      blackVisible: false,
      checkVisible: false, //审核弹窗
      // 表头
      columns: [
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'paramFormats',
          width: 100,
          scopedSlots: { customRender: 'paramFormats' },
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'account',
          width: 120,
          customRender: customRender,
        },
        {
          title: '短信内容',
          align: 'center',
          dataIndex: 'content',
          ellipsis: true,
          customRender: customRender,
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkRecord/page',
        audit: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkInfo/examine',
        send: process.env.VUE_APP_CMS_SMSBIZ + '/mgTkInfo/send',
      },
    };
  },
  methods: {
    add(record) {
      console.log(record);
      this.blackVisible = true;
    },
    getList() {
      let that = this;
      let params = {
        pageNo: that.ipagination.current,
        pageSize: that.ipagination.pageSize,
        impGroupId: that.auditList.impGroupId,
        impStatus: 0,
      };
      that.loading = true;
      postTag(this.url.list, params).then((res) => {
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    // 关闭审核详情
    handleClose() {
      this.blackVisible = false;
    },
    // 审核通过
    handleOk() {
      let that = this;
      that.$confirm({
        title: '提示',
        content: '审核通过该消息任务！',
        onOk: function () {
          that.checkVisible = false;
          postTag(that.url.audit, {
            id: that.auditList.id,
            taskStatus: 1,
          }).then((res) => {
            that.blackVisible = false;
            if (res.success) {
              that.$message.success(res.message);
              that.sendOk();
              that.$emit('ok');
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },
    // 发送
    sendOk() {
      postTag(this.url.send, {
        id: this.auditList.id,
      }).then((res) => {
        this.blackVisible = false;
        if (res.success) {
          this.$message.success(res.message);
          this.$emit('ok');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 审核驳回
    handleCancel() {
      this.checkVisible = true;
       this.auditReason = '';
    },
    // 取消
    handleReview() {
      this.checkVisible = false;
    },
    // 确定
    auditOk() {
      postTag(this.url.audit, {
        id: this.auditList.id,
        taskStatus: 2,
        reason: this.auditReason,
      }).then((res) => {
        this.blackVisible = false;
        this.checkVisible = false;
        if (res.success) {
          this.$message.success(res.message);
          this.$emit('ok');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .ant-modal-body {
  height: 500px;
  overflow: auto;
}
.taskModal-top {
  display: flex;
  justify-content: space-between;
}
.taskModal-top p {
  display: inline-block;
  color: #000;
  font-size: 16px;
  margin-right: 10px;
}
.taskModal-table {
  color: #000;
}
</style>
